import i18n from 'config/i18n';
import * as yup from 'yup';

import { getLocale } from 'utils/date';

const t = i18n.getFixedT(getLocale());

export const schema = yup.object({
  date: yup
    .date()
    .required(t('validationFieldRequired', { name: t('date') }))
    .nullable()
    .default(null),
  description: yup.string().required(t('holidays.errors.descriptionRequired')),
  holidayCompLeaveHours: yup
    .number()
    .min(0, t('holidays.errors.errorMinValue'))
    .max(9999.99, t('holidays.errors.errorMaxValue'))
    .typeError(t('holidays.errors.compensationRequired'))
});
